import React from "react";

import { Skeleton, ListItemProps as MuiListItemProps } from "@mui/material";
import { colors } from "@zapalacorp/tokens";
import { renderEmptyString } from "Util/names";

import {
  Badge,
  ListItemText,
  ListItem as ListemItemBase,
  TitleWithCounterContainer,
} from "./styled";

interface AppListItemProps {
  title?: React.ReactNode | string;
  isLoadingTitle?: boolean;
  subtitle?: React.ReactNode | string;
  isLoadingSubtitle?: boolean;
  children?: React.ReactNode;
  capitalizeSubtitle?: boolean;
  disableMargin?: boolean;
  renderCounter?: boolean;
  contentCountValue?: number;
  verifyIfIsEmpty?: boolean;
}

export const AppListItem = (props: AppListItemProps & MuiListItemProps) => {
  const {
    title,
    subtitle,
    children,
    isLoadingSubtitle,
    isLoadingTitle,
    capitalizeSubtitle,
    renderCounter,
    contentCountValue,
    disableMargin,
    disablePadding,
    verifyIfIsEmpty,
    ...rest
  } = props;

  const renderLoadingTitle = () => {
    if (isLoadingTitle) return <Skeleton variant="text" sx={{ fontSize: "14px" }} />;
    if (!isLoadingTitle && renderCounter) {
      return (
        <TitleWithCounterContainer>
          {title}
          <Badge>{contentCountValue}</Badge>
        </TitleWithCounterContainer>
      );
    }

    return title;
  };

  const renderLoadingSubtitle = () => {
    if (isLoadingSubtitle) return <Skeleton variant="text" sx={{ fontSize: "16px" }} />;
    if (verifyIfIsEmpty) return renderEmptyString(subtitle);

    return subtitle;
  };

  return (
    <ListemItemBase
      dense={!disablePadding}
      disableGutters={disablePadding}
      disablePadding={disablePadding}
      {...rest}
    >
      <ListItemText
        disableMargin={disableMargin}
        primary={renderLoadingTitle()}
        secondary={renderLoadingSubtitle()}
        primaryTypographyProps={{
          color: colors.gray600,
          fontFamily: "Manrope !important",
          fontSize: "14px !important",
          fontStyle: "normal !important",
          fontWeight: "600 !important",
          lineHeight: "20px !important",
          letterSpacing: "0.1px !important",
        }}
        secondaryTypographyProps={{
          color: `${colors.gray600} !important`,
          fontFamily: "Manrope !important",
          fontSize: "16px !important",
          fontStyle: "normal !important",
          fontWeight: "400 !important",
          lineHeight: "24px !important",
          letterSpacing: "0.5px !important",
          textTransform: capitalizeSubtitle ? "capitalize" : undefined,
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          overflow: "hidden",
          maxWidth: "215px",
          width: "100%",
          component: "span",
          display: "block",
        }}
      />
      {children}
    </ListemItemBase>
  );
};
